import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  display: flex;
  color: ${(props) => props.theme.newPalette.turquoise.T300};
  ${(props) => props.theme.newTypography.textStyleDisplayMedium};
  font-size: 14px;
  align-items: center;
  text-decoration: none;
`;

export const ReportContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 85%;
  margin: 0 auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 8px;
    gap: 8px;
    max-width: 100%;
    margin: 0;
  }
`;
